import $ from 'jquery';

// One request per feed, shared by every instance, including collapsed panels.
const feeds = {};
const REFRESH_GRACE_MS = 5 * 60 * 1000;

function element(tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = text;
  return node;
}

function updateDates() {
  document.querySelectorAll('[data-loan-rates]').forEach(widget => {
    const cards = Array.from(widget.querySelectorAll('[data-rate-api]'));
    const available = cards.filter(
      card => card.effective && card.effective.dateLabel
    );
    const labels = available.map(card => card.effective.dateLabel);
    let text = 'dates unavailable';
    if (
      available.length === cards.length &&
      labels.every(label => label === labels[0])
    ) {
      text = labels[0];
    } else if (available.length) {
      text = available
        .map(
          card =>
            `${card.getAttribute('data-product')}: ${card.effective.dateLabel}`
        )
        .join('; ');
      if (available.length < cards.length)
        text += ' (other effective dates not provided)';
    }
    if (cards.some(card => card.refreshPending))
      text += ' (last loaded rates; refresh pending)';
    widget.querySelector('[data-rates-date]').textContent = text;
  });
}

function showLoader(node) {
  ['rate', 'apr'].forEach(key => {
    const slot = node.querySelector(`[data-${key}-value]`);
    slot.textContent = '';
    slot.setAttribute('aria-label', `Loading ${key.toUpperCase()}`);
    const loader = element('span', 'loading loading--circle-bounce');
    loader.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < 3; i++)
      loader.appendChild(element('span', 'loading__ball'));
    slot.appendChild(loader);
  });
}

function clearCard(node) {
  node.effective = null;
  node.refreshPending = false;
  node
    .querySelectorAll('[data-rate-value], [data-apr-value]')
    .forEach(slot => slot.removeAttribute('aria-label'));
  node.querySelector('[data-rate-value]').textContent = '—';
  node.querySelector('[data-apr-value]').textContent = '—';
}

function render(node, data) {
  const precision = Number(
    node.closest('[data-loan-rates]').getAttribute('data-precision')
  );
  const quote = data.quote;
  if (!quote || !quote.effective || !quote.effective.label)
    throw new Error('Missing quote');
  ['rate', 'apr'].forEach(key => {
    const value = parseFloat(quote[key]);
    if (!Number.isFinite(value) || value <= 0) throw new Error('Invalid quote');
    node.querySelector(`[data-${key}-value]`).removeAttribute('aria-label');
    node.querySelector(`[data-${key}-value]`).textContent = `${value.toFixed(
      precision
    )}%`;
  });
  node.effective = quote.effective;
  node.refreshPending = false;
}

function refresh(feed) {
  if (feed.loading) return;
  feed.loading = true;
  clearTimeout(feed.timer);
  // Keep a last successful quote during a bounded background refresh.
  const retain = feed.staleUntil > Date.now();
  feed.nodes.forEach(node => {
    node.setAttribute('aria-busy', 'true');
    if (!retain) {
      clearCard(node);
      showLoader(node);
    } else {
      node.refreshPending = true;
    }
    node.querySelector('.loan-rates__status').textContent = '';
  });
  updateDates();
  const started = Date.now();
  $.ajax({ url: feed.url, dataType: 'json', timeout: 20000, cache: false })
    .done(data => {
      if (!data.quote || !(data.maxAge > 0)) {
        unavailable(feed);
        return;
      }
      // Subtract request time rather than depending on the visitor's clock.
      const remaining = data.maxAge * 1000 - (Date.now() - started);
      if (remaining <= 0) {
        unavailable(feed);
        return;
      }
      try {
        feed.nodes.forEach(node => {
          render(node, data);
          node.querySelector('.loan-rates__status').textContent = '';
        });
        updateDates();
        feed.expires = Date.now() + remaining;
        feed.staleUntil = feed.expires + REFRESH_GRACE_MS;
        clearTimeout(feed.expiryTimer);
        feed.expiryTimer = setTimeout(() => {
          feed.nodes.forEach(clearCard);
          updateDates();
        }, remaining + REFRESH_GRACE_MS);
        // Cross the server's whole-second cache boundary before requesting again.
        feed.timer = setTimeout(() => refresh(feed), remaining + 1000);
      } catch (error) {
        unavailable(feed);
      }
    })
    .fail(() => unavailable(feed))
    .always(() => {
      feed.loading = false;
      feed.nodes.forEach(node => node.setAttribute('aria-busy', 'false'));
    });
}

function unavailable(feed) {
  feed.expires = Date.now() + 30000;
  const retain = feed.staleUntil > Date.now();
  feed.nodes.forEach(node => {
    if (retain) node.refreshPending = true;
    else clearCard(node);
    const status = node.querySelector('.loan-rates__status');
    status.textContent = '';
    if (retain) return;
    const retry = element('button', 'loan-rates__retry', 'Retry');
    retry.type = 'button';
    retry.addEventListener('click', () => refresh(feed));
    status.appendChild(retry);
  });
  updateDates();
  feed.timer = setTimeout(() => refresh(feed), 30000);
}

updateDates();

document.querySelectorAll('[data-rate-url]').forEach(node => {
  const id = node.getAttribute('data-rate-url');
  if (!feeds[id]) {
    feeds[id] = { url: node.getAttribute('data-rate-url'), nodes: [] };
  }
  feeds[id].nodes.push(node);
});
Object.keys(feeds).forEach(id => refresh(feeds[id]));

function checkExpiry() {
  if (document.hidden) return;
  Object.keys(feeds).forEach(id => {
    if (Date.now() >= feeds[id].expires) refresh(feeds[id]);
  });
}
document.addEventListener('visibilitychange', checkExpiry);
window.addEventListener('pageshow', checkExpiry);

// Keep the existing accordion toggle behavior accessible from the keyboard.
$('.accordion__header[role="button"]').on('keydown', event => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    $(event.currentTarget).trigger('click');
  }
});
$('.accordion > .toggle__target').on(
  'toggle:afterShow toggle:afterHide',
  event => {
    $(event.currentTarget)
      .prev('.accordion__header')
      .attr(
        'aria-expanded',
        event.type === 'toggle:afterShow' ? 'true' : 'false'
      );
  }
);
